<template>
  <v-dialog
    :value="value"
    :max-width="maxWidth"
    :persistent="persistent"
    :content-class="contentClass"
    v-bind="$attrs"
    @input="$emit('input', $event)"
  >
    <div ref="surface" class="app-dialog__surface">
      <h2 v-if="hasTitle()" :id="titleId" class="app-dialog__title"><slot name="title">{{ title }}</slot></h2>
      <div class="app-dialog__body"><slot /></div>
      <div v-if="hasActions()" class="app-dialog__actions"><slot name="actions" /></div>
    </div>
  </v-dialog>
</template>

<script>
// Dialog (Spezifikation 2.6) als Hülle um v-dialog: Fläche weiß, Radius 6, Titel 18/24 600, Inhalt 13/20,
// Aktionen rechts mit Abstand 8 – „Abbrechen“ (secondary) links vom Bestätigen (primary bzw. danger, wiederholt das
// Verb). v-model wie bisher; persistent bleibt; blur zeichnet den Hintergrund weich; nested gestaltet den Dialog wie die
// Karten des Dashboards (grauer Rahmen mit Titel oben und Aktionen unten, dazwischen der Inhalt als weiße innere Karte;
// zuerst „Mandant wechseln“, Kundenwunsch 12.10.2026); scrollable lässt bei langem Inhalt nur den Inhalt scrollen
// (Titel und Aktionen bleiben stehen); weitere v-dialog-Optionen über Attribute. Slots: default,
// actions, title (statt der title-Prop).
export default {
  name: 'AppDialog',
  inheritAttrs: false,
  props: {
    value: { type: Boolean, default: false },
    title: { type: String, default: null },
    maxWidth: { type: [Number, String], default: 480 },
    persistent: { type: Boolean, default: false },
    // Hintergrund hinter dem Dialog weichzeichnen (z. B. Anmeldung beim Mandantenwechsel)
    blur: { type: Boolean, default: false },
    // wie die verschachtelten Karten des Dashboards
    nested: { type: Boolean, default: false },
    // langer Inhalt: nur der Inhalt scrollt, Titel und Aktionen bleiben sichtbar (Nachricht zur neuen Version)
    scrollable: { type: Boolean, default: false }
  },
  computed: {
    contentClass() {
      return ['app-dialog', this.blur ? 'app-dialog--blur' : '', this.nested ? 'app-dialog--nested' : '',
        this.scrollable ? 'app-dialog--scroll' : ''].filter(Boolean).join(' ');
    },
    titleId() {
      return 'app-dialog-' + this._uid + '-titel';
    }
  },
  watch: {
    value(open) {
      if (open) {
        this.$nextTick(this.labelDialog);
      }
    }
  },
  mounted() {
    if (this.value) {
      this.$nextTick(this.labelDialog);
    }
  },
  methods: {
    hasTitle() {
      return !!this.title || !!this.$slots.title || !!this.$scopedSlots.title;
    },
    hasActions() {
      return !!this.$slots.actions || !!this.$scopedSlots.actions;
    },
    // Vuetify setzt role="dialog" am äußeren Inhaltselement; der Titel benennt den Dialog
    labelDialog() {
      const surface = this.$refs.surface;
      const dialog = surface && surface.closest ? surface.closest('[role="dialog"]') : null;
      if (dialog && this.hasTitle()) {
        dialog.setAttribute('aria-labelledby', this.titleId);
      }
    }
  }
};
</script>
